import { getDay, parseISO } from 'date-fns'
export default {
  methods: {
    /**
     * Get a calendar grid by splitting all year dates array into chunks by weeks
     * Input : [{date: '2020-01-01'}, ..., {date: '2020-12-31'}]
     * Output : [
     *  [{date: '2020-01-01'}, ..., {date: '2020-01-07'}],
     *  [{date: '2020-01-08'}, ..., {date: '2020-01-14'}],
     *  ...,
     * ]
     * Note : Take into account the size of the first week
     */
    generateCalendarGrid (datesArray = []) {
      const chunks = []
      let index = 0;
      while (index < datesArray.length) {
        let weekSize = 7
        if (0 === index) {
          weekSize = this.getWeekDayRemaining(parseISO(datesArray[0].date))
        }
        chunks.push(datesArray.slice(index, weekSize + index))
        index += weekSize;
      }
      return chunks
    },

    getWeekDayRemaining(date) {
      const weekSize = {
        0: 1,
        1: 7,
        2: 6,
        3: 5,
        4: 4,
        5: 3,
        6: 2,
      }
      return weekSize[getDay(date)]
    }
  }
}